import { AxiosInstance } from "axios";
import CommonCRUD from "modules/CommonCRUD";

class Admins extends CommonCRUD {}

export default Admins;
